import Form from '../../../CompUtils/Form';
import { InscripcionForm } from './InscripcionForm';

type Props = {
  requisitos: any;
  setRequisitos: (requisitos: any) => void;
  handleSubmitStep1: () => void;
  enabledButtonAceptar: boolean;
  tieneCV: boolean;
};

const Step1Requisitos = (props: Props) => {
  const { requisitos, setRequisitos, handleSubmitStep1, enabledButtonAceptar, tieneCV } = props;

  const toggleButtons = () => {
    return enabledButtonAceptar || !tieneCV;
  };

  return (
    <>
      {/* Se quita temportalmente por decision del cliente el dia 16/06/2023 */}
      {/* <div className="row">
        <div className="col-12">
          <PreRequisitos />
        </div>
      </div> */}
      <Form
        noBtns={toggleButtons()}
        submitText="Continuar"
        onSubmit={handleSubmitStep1}
        btns={['submit']}>
        <InscripcionForm requisitos={requisitos} setRequisitos={setRequisitos} />
      </Form>
    </>
  );
};

export default Step1Requisitos;
